"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirQualityThresholds = exports.AirQualityEventType = void 0;
var AirQualityEventType;
(function (AirQualityEventType) {
    AirQualityEventType["InternalAirQuality"] = "AIR_QUALITY";
    AirQualityEventType["ExternalAirQuality"] = "OUTDOOR_AIR_QUALITY";
    AirQualityEventType["AQI"] = "aqi";
    AirQualityEventType["AirPressure"] = "air_pressure";
    AirQualityEventType["CoolantPressure"] = "coolant_pressure";
    AirQualityEventType["FilterMain"] = "FILTER_STATUS_MAIN";
    AirQualityEventType["FilterSecondary"] = "FILTER_STATUS_SECONDARY";
    AirQualityEventType["Temperature"] = "TEMPERATURE";
    AirQualityEventType["Humidity"] = "HUMIDITY";
})(AirQualityEventType = exports.AirQualityEventType || (exports.AirQualityEventType = {}));
exports.AirQualityThresholds = {
    eaq: {
        good: 350,
        moderate: 859,
        unhealthy: 860,
    },
    iaq: {
        excellent: 50,
        good: 100,
        lightlyPolluted: 150,
        moderatelyPolluted: 200,
        heavilyPolluted: 250,
        severelyPolluted: 350,
        extremelyPolluted: 500,
    },
    pm25: {
        good: 0.28,
        moderate: 0.68,
    },
};
